import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { share, map, tap } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';


@Injectable({
  providedIn: 'root'
})
export class AppService {

  token;
  refreshToken;
  headersPlatos: any[] = [
    { field: 'nombre', header: 'Descripción' }
  ];
  platos: any[] = [
    { nombre: 'Empanadas (4): carne / pollo / humita / jamón y queso / cebolla y queso / caprese' },
    { nombre: 'Croquetas de acelga (sin huevo) con guarnición' },
    { nombre: 'Ensalada CAESAR: verdes, pollo, croutons y queso parmesano' },
    { nombre: 'Ensalada FRESH: tomate, choclo, papa, huevo y zanahoria' },
    { nombre: 'Ensalada HUERTA SIN VERDES: zanahoria rallada, arroz yamaní, choclo, repollo y huevo' },
    { nombre: 'Ensalada HUERTA: ensalada de verdes, zanahoria rallada, arroz yamaní, repollo y huevo' },
    { nombre: 'Ensalada MEDITERRANEA: pasta, tomate, albahaca, queso y aceitunas negras' },
    { nombre: 'Ensalada MEX: verdes, pollo alimonado, tomates cherry, guacamole y crocante de maíz' },
    { nombre: 'Ensalada PASTA: ensalada de pasta fría con tomates secos, verdes, queso y champignones fileteados' },
    { nombre: 'Ensalada POLLO CRYSPY: ensalada de mix verdes, tomate, choclo, maní y pollo apanado en avena' },
    { nombre: 'Ensalada PRIMAVERA: queso, choclo, tomate, jamón y huevo' },
    { nombre: 'Medallón de lentejas o porotos aduki con guarnición' }
  ];
  constructor(
    private httpService: HttpService,
    private http: HttpClient) { }

  getPlatos() {
    return this.platos;
  }
  getHeadersPlatos() {
    return this.headersPlatos;
  }
  getToken() {
    return this.token;
  }
  getRefreshToken() {
    return this.refreshToken;
  }
  setToken(value) {
    this.token = value;
  }
  setRefreshToken(value) {
    this.refreshToken = value;
  }
  renewToken() {
    this.setToken(localStorage.getItem('refreshToken'));
    localStorage.setItem('token', localStorage.getItem('refreshToken'));
    return this.http.get<any>(this.httpService.getBaseURL() + 'auth/token').pipe(
      tap((data) => {
        localStorage.setItem('token', data.token);
        this.setToken(data.token);
      })
    )
  }
}